export const defaultColumns = [
  { label: 'Tipo', value: 'applicable_entity' },
  { label: 'Nome', value: 'display_name' },
  { label: 'Ult. Atualização', value: 'updated_at' },
  { label: 'Ações', value: 'actions', className: 'w-9' },
];